import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './printer.css';

class Printer extends Component{
    constructor(props){
        super(props);
        this.printContent = this.printContent.bind(this);
    }

    styleHeadings(id){
        let headings = document.getElementById(id).querySelectorAll(".accordion-background");
        Array.prototype.forEach.call(headings, item => {
            item.style.fontSize="24px";
            item.style.fontWeight="600";
          });
    }

    openContentPanels(id){
        let guideContent= document.getElementById(id).querySelectorAll(".accordion-panel");
        [].forEach.call(guideContent, link => {
            if(link.hasAttribute("hidden")){
                link.removeAttribute("hidden");
            }
        });
    }

    printContentToDevice(id){        
        const pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        const template = document.getElementById(id);        
        template.style.fontSize="16px";
        pri.document.write(template.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    }

    printContent(){
        const containerId = "printtemplate";
        const content = document.getElementById(`${this.props.parentContainer}`); 
        let container = document.createElement("div");
        container.id= containerId;
        container.innerHTML = content.innerHTML;
        container.style.display="none";
        document.body.appendChild(container);
        this.openContentPanels(containerId);
        this.styleHeadings(containerId); 
        this.printContentToDevice(containerId);
        const removeNode = document.getElementById(containerId);
        document.body.removeChild(removeNode); 
    }

    /*
        Please note : InOrder to use this component on stepbystep guides. 
            Please provide the parent node as props
            Make sure that all AccordionItemButton has class accordion-background
            Make sure that all AccordionItemPanel has class accordion-panel
     */
    render(){
        const printIcon = process.env.BASE_URL + "images/app/printicon.png";
        return(
            <div>
                <iframe id="ifmcontentstoprint" className="print-frame"></iframe>
                <div onClick={this.printContent} className="print">
                    <img src={printIcon} className="icon-image" alt="Print Page" title="Print page"/>
                </div>
            </div>
        )}

}

Printer.propTypes = {
    parentContainer: PropTypes.string
  }

export default Printer;